import React, {Suspense} from 'react';
import PageLayout from "@view/layout/pageLayout/PageLayout";
import SpinnerCustom from "@ui/spinner/SpinnerCustom";
import {VideoSingleVoyagesLazy} from "@containers/singleVoyage/video/VideoSingleVoyages.lazy";

const VideoSingleVoyagesPage = () => {

	return (
		<PageLayout>
			<Suspense
				fallback={<SpinnerCustom/>}
			>
				<VideoSingleVoyagesLazy/>
			</Suspense>
		</PageLayout>
	);
};

export default VideoSingleVoyagesPage;
